import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { useShallow } from "zustand/shallow";
import { CountryInput } from "../../../../../components/filters/Locations/CountryInput";
import { CollectionSelect } from "../../../../../components/CollectionSelect/CollectionSelect";
import { ItemSelect } from "./ItemSelect";
import { useCollectionDialogStore } from "../stores/CollectionDialogStore";

export const CompositeSelect: FC = () => {
  const {
    type,
    country,
    items,
    setItems,
    setCountry,
    setItemsFromCollectionOption,
    editingCollectionId,
  } = useCollectionDialogStore(
    useShallow((state) => ({
      type: state.type,
      country: state.country,
      items: state.items,
      setItems: state.setItems,
      setCountry: state.setCountry,
      setItemsFromCollectionOption: state.setItemsFromCollectionOption,
      editingCollectionId: state.editingCollectionId,
    }))
  );

  const shouldShowCountryInput = type === "state";
  const shouldDisableCollectionSelect = shouldShowCountryInput && !country;

  return (
    <>
      <Stack flexDirection="column" alignItems="start" gap={1}>
        <Typography variant="h3">Add Records</Typography>
        <Typography variant="body1" color="textSecondary">
          Search to select to add records
        </Typography>
      </Stack>

      {shouldShowCountryInput && (
        <CountryInput
          placeholderText="Country"
          isMultiple={false}
          selectedItems={[country]}
          onCountrySelect={(countryAlpha2s) => setCountry(countryAlpha2s[0])}
        />
      )}

      <CollectionSelect
        placeholder={
          shouldDisableCollectionSelect
            ? "Select a country first"
            : "Search collections"
        }
        type={type}
        disabled={shouldDisableCollectionSelect}
        onSelect={setItemsFromCollectionOption}
        excludeId={editingCollectionId || undefined}
      />

      <ItemSelect
        collectionType={type}
        country={country}
        selectedItems={items}
        onSelect={setItems}
      />
    </>
  );
};
